/**************************************************************************************************/
/*   File: /src/app/stores/selectors/router/selectors.ts                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as fromRouter from '@ngrx/router-store/src/router_store_module';
import { createFeatureSelector, createSelector } from '@ngrx/store';

/**
 * Get the router State
 */
export const getRouterState = createFeatureSelector<fromRouter.RouterReducerState>('router');
/**
 * Get the url
 */
export const getUrl = createSelector(
    getRouterState,
    (state: fromRouter.RouterReducerState) => state.state && state.state.url
);
